import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const CalloutBox = makeShortcode("CalloutBox");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <CalloutBox type="fyi" title="Visit our Trust Center" mdxType="CalloutBox">
      <p>{`Utilize our `}<a parentName="p" {...{
          "href": "https://trust.posthog.com"
        }}>{`Trust Center`}</a>{` powered by SafeBase to self-serve reports, policies, and certifications.`}</p>
    </CalloutBox>
    <p>{`PostHog is certified as SOC 2 Type II compliant, following an external audit. `}</p>
    <p>{`Our latest `}<a parentName="p" {...{
        "href": "https://drive.google.com/file/d/1gZNorQK3Pq9KqNvUWXMNJsdQpUwxzKNe/view?usp=sharing"
      }}>{`security report`}</a>{` is publicly available (covering controls as of May 31st, 2025). `}</p>
    <h3 {...{
      "id": "policies"
    }}>{`Policies`}</h3>
    <p>{`We have a number of policies in place to support SOC 2 compliance. All team members have been invited to Drata to review these and to complete security training and background checks as part of onboarding.`}</p>
    <p>{`All of our policies are available for viewing and upon request via our `}<a parentName="p" {...{
        "href": "https://trust.posthog.com"
      }}>{`Trust Center`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      